import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetAPICommand} from '@drl/core/core.module';
import {environment} from '@drl/env/environment';

export class GetTherapyAdherenceCommand<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>, id: number) {
    super(
      apiService,
      adapter,
      `${environment.patientApiUrl}/patients/${id}/appointments/therapy-adherence`,
    );
  }
}
